const IconLive = () => (
    <svg
        width="11"
        height="11"
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_11653_9956)">
            <path
                d="M5.06836 2.75C6.17285 2.75 7.06824 3.64554 7.06836 4.75C7.06836 5.85457 6.17293 6.75 5.06836 6.75C3.96379 6.75 3.06836 5.85457 3.06836 4.75C3.06848 3.64554 3.96387 2.75 5.06836 2.75Z"
                fill="currentColor"
            />
            <mask
                id="mask0_11653_9956"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="8"
                y="0"
                width="3"
                height="10"
            >
                <rect
                    x="8.06836"
                    y="0.25"
                    width="2"
                    height="9"
                    fill="currentColor"
                />
            </mask>
            <g mask="url(#mask0_11653_9956)">
                <path
                    d="M7.56836 9.25C7.07391 9.25 6.59056 8.98608 6.17943 8.49161C5.76831 7.99715 5.44788 7.29434 5.25866 6.47208C5.06944 5.64981 5.01993 4.74501 5.1164 3.87209C5.21286 2.99918 5.45096 2.19736 5.80059 1.56802C6.15022 0.938685 6.59568 0.510102 7.08063 0.336468C7.56559 0.162835 8.06825 0.25195 8.52507 0.592544C8.98188 0.933138 9.37233 1.50991 9.64703 2.24994C9.92174 2.98996 10.0684 3.85999 10.0684 4.75C10.0684 5.94347 9.80497 7.08807 9.33613 7.93198C8.86729 8.77589 8.2314 9.25 7.56836 9.25ZM7.56836 1C7.15632 1 6.75352 1.21994 6.41092 1.63199C6.06832 2.04405 5.80129 2.62972 5.64361 3.31494C5.48593 4.00016 5.44467 4.75416 5.52506 5.48159C5.60544 6.20902 5.80386 6.8772 6.09522 7.40165C6.38658 7.9261 6.75779 8.28325 7.16192 8.42795C7.56605 8.57264 7.98494 8.49838 8.36562 8.21455C8.7463 7.93072 9.07167 7.45007 9.30059 6.83339C9.52951 6.2167 9.65169 5.49168 9.65169 4.75C9.65169 3.75544 9.4322 2.80161 9.0415 2.09835C8.6508 1.39509 8.12089 1 7.56836 1Z"
                    fill="currentColor"
                />
            </g>
            <mask
                id="mask1_11653_9956"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="7"
                y="2"
                width="3"
                height="6"
            >
                <rect
                    x="7.06836"
                    y="2.25"
                    width="2"
                    height="5"
                    fill="currentColor"
                />
            </mask>
            <g mask="url(#mask1_11653_9956)">
                <path
                    d="M6.56836 7.25C6.07391 7.25 5.59056 7.10338 5.17943 6.82867C4.76831 6.55397 4.44788 6.16352 4.25866 5.70671C4.06944 5.24989 4.01993 4.74723 4.1164 4.26228C4.21286 3.77732 4.45096 3.33187 4.80059 2.98223C5.15022 2.6326 5.59568 2.3945 6.08063 2.29804C6.56559 2.20157 7.06825 2.25108 7.52507 2.4403C7.98188 2.62952 8.37233 2.94995 8.64703 3.36108C8.92174 3.7722 9.06836 4.25555 9.06836 4.75C9.06836 5.41304 8.80497 6.04893 8.33613 6.51777C7.86729 6.98661 7.2314 7.25 6.56836 7.25ZM6.56836 2.66667C6.15632 2.66667 5.75352 2.78885 5.41092 3.01777C5.06832 3.24669 4.80129 3.57206 4.64361 3.95274C4.48593 4.33342 4.44467 4.75231 4.52506 5.15644C4.60544 5.56057 4.80386 5.93178 5.09522 6.22314C5.38658 6.5145 5.75779 6.71292 6.16192 6.7933C6.56605 6.87369 6.98494 6.83243 7.36562 6.67475C7.7463 6.51707 8.07167 6.25004 8.30059 5.90744C8.52951 5.56484 8.65169 5.16205 8.65169 4.75C8.65169 4.19747 8.4322 3.66756 8.0415 3.27686C7.6508 2.88616 7.12089 2.66667 6.56836 2.66667Z"
                    fill="currentColor"
                />
            </g>
            <mask
                id="mask2_11653_9956"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="3"
                height="10"
            >
                <rect
                    width="2"
                    height="9"
                    transform="matrix(-1 0 0 1 2.06836 0.25)"
                    fill="currentColor"
                />
            </mask>
            <g mask="url(#mask2_11653_9956)">
                <path
                    d="M2.56836 9.25C3.06281 9.25 3.54616 8.98608 3.95728 8.49161C4.36841 7.99715 4.68884 7.29434 4.87806 6.47208C5.06728 5.64981 5.11678 4.74501 5.02032 3.87209C4.92386 2.99918 4.68576 2.19736 4.33613 1.56802C3.98649 0.938685 3.54104 0.510102 3.05608 0.336468C2.57113 0.162835 2.06847 0.25195 1.61165 0.592544C1.15484 0.933138 0.764389 1.50991 0.489685 2.24994C0.214982 2.98996 0.0683594 3.85999 0.0683594 4.75C0.0683594 5.94347 0.331751 7.08807 0.800592 7.93198C1.26943 8.77589 1.90532 9.25 2.56836 9.25ZM2.56836 1C2.9804 1 3.38319 1.21994 3.7258 1.63199C4.0684 2.04405 4.33542 2.62972 4.49311 3.31494C4.65079 4.00016 4.69205 4.75416 4.61166 5.48159C4.53128 6.20902 4.33286 6.8772 4.0415 7.40165C3.75014 7.9261 3.37892 8.28325 2.9748 8.42795C2.57067 8.57264 2.15178 8.49838 1.7711 8.21455C1.39042 7.93072 1.06505 7.45007 0.836131 6.83339C0.607211 6.2167 0.485026 5.49168 0.485026 4.75C0.485026 3.75544 0.704519 2.80161 1.09522 2.09835C1.48592 1.39509 2.01582 1 2.56836 1Z"
                    fill="currentColor"
                />
            </g>
            <mask
                id="mask3_11653_9956"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="1"
                y="2"
                width="3"
                height="6"
            >
                <rect
                    width="2"
                    height="5"
                    transform="matrix(-1 0 0 1 3.06836 2.25)"
                    fill="currentColor"
                />
            </mask>
            <g mask="url(#mask3_11653_9956)">
                <path
                    d="M3.56836 7.25C4.06281 7.25 4.54616 7.10338 4.95728 6.82867C5.36841 6.55397 5.68884 6.16352 5.87806 5.70671C6.06728 5.24989 6.11678 4.74723 6.02032 4.26228C5.92386 3.77732 5.68576 3.33187 5.33613 2.98223C4.98649 2.6326 4.54104 2.3945 4.05608 2.29804C3.57113 2.20157 3.06847 2.25108 2.61165 2.4403C2.15484 2.62952 1.76439 2.94995 1.48969 3.36108C1.21498 3.7722 1.06836 4.25555 1.06836 4.75C1.06836 5.41304 1.33175 6.04893 1.80059 6.51777C2.26943 6.98661 2.90532 7.25 3.56836 7.25ZM3.56836 2.66667C3.9804 2.66667 4.38319 2.78885 4.7258 3.01777C5.0684 3.24669 5.33542 3.57206 5.49311 3.95274C5.65079 4.33342 5.69205 4.75231 5.61166 5.15644C5.53128 5.56057 5.33286 5.93178 5.0415 6.22314C4.75014 6.5145 4.37892 6.71292 3.9748 6.7933C3.57067 6.87369 3.15178 6.83243 2.7711 6.67475C2.39042 6.51707 2.06505 6.25004 1.83613 5.90744C1.60721 5.56484 1.48503 5.16205 1.48503 4.75C1.48503 4.19747 1.70452 3.66756 2.09522 3.27686C2.48592 2.88616 3.01582 2.66667 3.56836 2.66667Z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
);

export default IconLive;
